module.exports = __webpack_public_path__ + "img/fog.d4276345.svg";